interface IProps {
    title: string;
}

const IncomeTitle = ({ title }: IProps) => {
    return (
        <div className='o-fieldset__row mb-0'>
            <div className='o-layout'>
                <div className='o-layout__item  u-1/1  u-1/1@xs '>
                    <p>
                        <strong>{title}</strong>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default IncomeTitle;
